<template>
  <div class="cmp-footer">
    <!-- <div class="footer-wrap g-wrap g-container"> -->
    <div class="footer-wrap">
      <div class="right" style="display:none;">
        <!-- <p class="mb-20" style="font-size:18px;color:#fff;">友情链接</p> -->
        <div class="footer-link">
          <div class="link-tab" v-for="(item,index) in dataList" :key="index">
            <div class="item">
              <p class="name mb-20" @click="showSub(index)">{{item.name}}</p>
              <router-link tag="a" :to="it.url" v-for="(it,i) in item.childList" :key="i" replace v-show="subIndex===index">{{it.name}}</router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="left">
        <div class="logo" style="display:none;">
          <img src="~@images/logo-2.png" alt="">
        </div>
        <div class="icons-link">
          <p class="name">关注我们</p>
          <div class="icon-list">
            <div class="icon-item" v-for="(item, i) in focusList" :key="i">
              <img :src="item.url" alt="">

              <div class="pic-pop anim">
                <div class="pic">
                  <img :src="item.qrcode" alt="" title="">
                </div>
              </div>
            </div>
            <!-- <div class="icon-item">
              <img src="~@images/foot-wechat.png" alt="">
            </div>
            <div class="icon-item">
              <img src="~@images/foot-link.png" alt="">
            </div>
            <div class="icon-item">
              <img src="~@images/foot-douyin.png" alt="">
            </div> -->
          </div>
        </div>
        <div class="contact">
          <p class="name">联系我们</p>
          <div class="info">
            <p>辽宁省沈阳市浑南区智慧三街157号</p>
            <p class="mt-5">024-23205102-5100</p>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-suport">
      <p><a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">辽ICP备11007072号-1</a></p>
      <p>版权所有：Copyright©2022 辽宁省博物馆</p>
      <!-- <p>版权所有：Copyright©2022 辽宁省博物馆 All Rights Reserved.</p> -->
      <p>技术支持：北京探景科技有限公司</p>
    </div>
  </div>
</template>

<script>
// import QrcodeVue from 'qrcode.vue'
// import Popper from 'vue-popperjs';
// import 'vue-popperjs/dist/vue-popper.css';
export default {
  components: {
    // QrcodeVue,
    // popper: Popper
  },
  data() {
    return {
      visible: false,
      dataList: [
        {
          name: '导览',
          url: '/exhibition',
          childList: [
            {
              name: '开放时间',
              url: '/museum/open-time?type=1'
            },
            {
              name: '交通路线',
              url: '/museum/traffic?type=3'
            },
            {
              name: '票务信息',
              url: '/museum/ticket?type=2'
            },
            {
              name: '参观须知',
              url: '/museum/notice?type=4'
            },
            {
              name: '馆内服务',
              url: '/museum/explain?type=6'
            },
          ]
        },
        {
          name: '藏品',
          url: '/exhibition',
          childList: [
            {
              name: '馆藏精品',
              url: '/collect'
            },
            {
              name: '3D 藏品',
              url: '/collect/list'
            },
            {
              name: '数字文物库',
              url: '/collect/digital-culture'
            }
          ]
        },
        {
          name: '学术',
          url: '/research',
          childList: [
            {
              name: '科研课题',
              url: '/research'
            },
            {
              name: '学术会议',
              url: '/research?pageType=2'
            },
            {
              name: '精品图录',
              url: '/research?pageType=3'
            },
            {
              name: '学术论文',
              url: '/research?pageType=4'
            },
            {
              name: '辽博讲堂',
              url: '/research?pageType=5'
            },
          ]
        },
        {
          name: '关于',
          url: '/about',
          childList: [
            {
              name: '本馆概述',
              url: '/about'
            },
            {
              name: '资讯',
              url: '/about?pageType=2'
            },
            {
              name: '领导',
              url: '/about?pageType=3'
            },
            {
              name: '机构设置',
              url: '/about?pageType=4'
            },
            {
              name: '专家介绍',
              url: '/about?pageType=5'
            },
          ]
        },
        {
          name: '展览',
          url: '/exhibition',
          childList: [
            {
              name: '常设展览',
              url: '/exhibition?type=0&from=footer'
            },
            {
              name: '临时展览',
              url: '/exhibition?type=1&from=footer'
            },
            {
              name: '微展览',
              url: '/exhibition?type=2&from=footer'
            },
            {
              name: '数字展厅',
              url: '/exhibition?type=4&from=footer'
            },
          ]
        },
        {
          name: '教育',
          url: '/exhibition',
          childList: [
            {
              name: '社教活动',
              url: '/education?type=0&from=footer'
            },
            {
              name: '线上课程',
              url: '/education?type=1&from=footer'
            },
            {
              name: '儿童体验馆',
              url: '/education?type=2&from=footer'
            },
            {
              name: '辽博志愿者',
              url: '/education?type=3&from=footer'
            },
          ]
        },
        {
          name: '文创',
          url: '/creative',
          childList: [
            {
              name: '文创产品',
              url: '/creative'
            }
          ]
        },
      ],
      focusList: [
        {
          name: '微博',
          url: require('@images/foot-webo.png'),
          qrcode: require('@images/code-weibo.png'),
        },
        {
          name: '微信',
          url: require('@images/foot-wechat.png'),
          qrcode: require('@images/code-wechat.png'),
        },
        // {
        //   name: '链接',
        //   url: require('@images/foot-link.png'),
        //   qrcode: require('@images/foot-webo.png'),
        // },
        {
          name: '抖音',
          url: require('@images/foot-douyin.png'),
          qrcode: require('@images/code-douyin.png'),
        },
      ],

      dataList2: [
        {
          name: '首页',
          url: '/home',
          childList: []
        },
        {
          name: '展览',
          url: '/exhibition',
          childList: [
            {
              name: '陈列展览',
              url: '/exhibition?type=1'
            },
            {
              name: '临时展览',
              url: '/exhibition?type=2'
            },
            {
              name: '数字展览',
              url: '/exhibition?type=3'
            }
          ]
        },
        {
          name: '馆藏',
          url: '/collect',
          childList: [
            {
              name: '馆藏精品',
              url: '/collect?type=1'
            },
            {
              name: '藏品数据库',
              url: '/collect?type=2'
            },
            {
              name: '藏品征集',
              url: '/collect?type=3'
            },
            {
              name: '社会捐赠',
              url: '/collect?type=4'
            }
          ]
        },
        {
          name: '教育',
          url: '/activity',
          childList: [
            {
              name: '社交活动',
              url: '/activity'
            }
          ]
        },
        {
          name: '研究',
          url: '/research',
          childList: [
            {
              name: '科研课题',
              url: '/research?type=1'
            },
            {
              name: '学术会议',
              url: '/research?type=2'
            },
            {
              name: '专著',
              url: '/research?type=3'
            },
            {
              name: '年鉴',
              url: '/research?type=4'
            },
            {
              name: '论文',
              url: '/research?type=4'
            },
            {
              name: '馆刊',
              url: '/research?type=4'
            }
          ]
        },
        {
          name: '文创',
          url: '/creative',
          childList: [
            {
              name: '文创列表',
              url: '/creative'
            }
          ]
        },
        {
          name: '动态',
          url: '/dynamic',
          childList: [
            {
              name: '新闻资讯',
              url: '/dynamic?type=1'
            },
            {
              name: '通知公告',
              url: '/dynamic?type=2'
            },
            {
              name: '视频资源',
              url: '/dynamic?type=3'
            }
          ]
        },
        {
          name: '概览',
          url: '/overview',
          childList: [
            {
              name: '关于我馆',
              url: '/overview?type=1'
            },
            {
              name: '管理与建设',
              url: '/overview?type=2'
            },
            {
              name: '参观服务',
              url: '/overview?type=3'
            },
            {
              name: '联系我们',
              url: '/overview?type=4'
            }
          ]
        },
        {
          name: '志愿者',
          url: '/volunteer',
          childList: []
        }
      ],

      subIndex: ''
    }
  },
  methods: {
    close() {
      this.visible = true
      this.$nextTick(() => {
        this.visible = false
      })
    },
    showSub(i) {
      if(this.subIndex === i) {
        this.subIndex = ''
        return
      }
      this.subIndex = i
    }
  },
}
</script>

<style lang="scss" scoped>
.cmp-footer {
  padding: 47px 0;
  background: #3D3D3D;
  color: #fff;
  // height: 196px;
  // background: url(~@images/footer-bg.jpg) no-repeat top center;
  // background-size: cover;
  // position: absolute;
  // left: 0;
  // bottom: 0;
  // width: 100%;
  a {
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    margin-top: 5px;
  }
  .footer-wrap {
    // display: flex;
    width: $minWidth;
    margin: 0 auto;
    .left {
      width: 500px;
      font-size: 24px;
      .logo {
        img {
          width: 159px;
        }
      }
      .name {
        margin-top: 44px;
        margin-bottom: 20px;
        font-size: 26px;
      }
      .icons-link {
        .icon-list {
          margin-top: 15px;
          display: flex;
          .icon-item {
            position: relative;
            margin-right: 56px;
            cursor: pointer;
            img {
              width: 105px;
              height: 105px;
              object-fit: contain;
            }

            .pic-pop.anim {
              position: absolute;
              left: 50%;
              bottom: 100%;
              z-index: 3;
              margin-bottom: 10px;
              opacity: 0;
              padding: 8px;
              visibility: hidden;
              border-radius: 5px;
              // transition: all 0.3s;
              background: #fff;
              &::before {
                content: '';
                width: 12px;
                height: 12px;
                background-color: #fff;
                border: 1px solid #ddd;
                position: absolute;
                z-index: -1;
                left: 50%;
                top: 100%;
                transform: translate(-50%, -50%) rotate(45deg);
              }
              &:after {
                content: '';
                position: absolute;
                z-index: -1;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                background-color: #fff;
                border-radius: 5px;
              }
              .pic {
                width: 150px;
                img {
                  width: 100%;
                  height: 150px;
                }
              }
            }
            &:hover {
              .pic-pop {
                opacity: 1;
                visibility: visible;
              }
              .pic-pop.anim {
                transform: translate(-50%, 0%);
              }
            }
          }
        }
      }
      &:first-child {
        .name {
          margin-top: 0;
        }
      }
    }
    .right {
      flex: 1;
      .footer-link {
        // display: flex;
        flex-wrap: wrap;
        .link-tab {
          margin-bottom: 50px;
          width: 270px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          .item {
            padding-left: 10px;
            border-left: solid 1px $primary;
            display: flex;
            flex-direction: column;
            .name {
              font-size: 18px;
            }
            .link-btn {
              margin-bottom: 10px;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
  .footer-suport {
    // width: 438px;
    // margin: 0 auto;
    margin-top: 63px;
    // background: #292428;
    // background: rgba($color: #292428, $alpha: .5);
    text-align: center;
    font-size: 14px;
    p {
      margin-bottom: 5px;
      &:last-child {
        margin-bottom: 0;
      }
      a {
        font-size: 14px;
      }
    }
  }
}
</style>
